import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import RegisterForm from "../../sections/RegisterForm/RegisterForm";
import "./Register.css";

const SITE_KEY = "6LcI1fgrAAAAAJuOhpKjm-SGUcQkuJBgC4S2nDXn"; // reCAPTCHA v3 site key

function Register() {
  return (
    <main className="Register auth-page">
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
        <RegisterForm />
      </GoogleReCaptchaProvider>
    </main>
  );
}

export default Register;
